import { combineReducers } from "redux";
import errorReducer from "./errorReducers";
import authReducer from "./authReducers";
import dataReducer from "./dataReducers";
import articleReducer from "./articleReducers";
import cheatsheetReducer from "./cheatsheetReducers"
import contactReducer from "./contactReducers";
import subscribeReducer from "./subscribeReducers";
import textReducer from "./textReducers";
import projectReducer from "./projectReducers";
import skillReducer from "./skillReducers";
import commentReducer from "./commentReducers";
import analyticsReducer from "./analyticsReducers";
import togglReducer from "./togglReducer";
import contentReducer from "./contentReducer";
import publicContentReducer from "./publicContentReducer";
import seriesReducer from "./seriesReducers";
import insightsReducer from "./insightsReducers";
import tagReducer from "./tagReducers";

export default combineReducers({
  auth: authReducer,
  data: dataReducer,
  article: articleReducer,
  cheatsheet:cheatsheetReducer,
  subscribe: subscribeReducer,
  contact: contactReducer,
  text: textReducer,
  project: projectReducer,
  skill: skillReducer,
  comment: commentReducer,
  analytics: analyticsReducer,
  toggl: togglReducer,
  content: contentReducer,
  publicContent: publicContentReducer,
  series: seriesReducer,
  insights: insightsReducer,
  tags: tagReducer,
  errors: errorReducer,
});
